import { Skeleton } from "@/components/ui/skeleton";

export const ListingCardSkeleton = () => (
  <div className="overflow-hidden rounded-xl border border-border/40 bg-card shadow-sm">
    <Skeleton className="aspect-[16/9] w-full rounded-none" />
    <div className="space-y-2 px-3 pb-3 pt-2">
      <div className="flex items-center justify-between gap-2">
        <Skeleton className="h-3 w-20" />
        <Skeleton className="h-4 w-28" />
      </div>
      <Skeleton className="h-3 w-2/3" />
      <Skeleton className="h-5 w-24" />
      <Skeleton className="mt-1 h-9 w-full rounded-lg" />
    </div>
  </div>
);

export const ListingGridSkeleton = ({ count = 6 }: { count?: number }) => (
  <div className="grid gap-3 md:grid-cols-2 md:gap-4 xl:grid-cols-3">
    {Array.from({ length: count }).map((_, i) => (
      <ListingCardSkeleton key={i} />
    ))}
  </div>
);

export const ListingDetailsSkeleton = () => (
  <section className="min-h-screen bg-background px-4 py-10 sm:px-6 lg:px-8">
    <div className="mx-auto max-w-6xl">
      <Skeleton className="mb-6 h-5 w-24" />
      <div className="grid gap-8 lg:grid-cols-[1.2fr_0.8fr]">
        <Skeleton className="aspect-[4/3] rounded-2xl" />
        <div className="space-y-4">
          <Skeleton className="h-10 w-3/4" />
          <Skeleton className="h-4 w-1/3" />
          <Skeleton className="h-12 w-1/2" />
          <div className="grid grid-cols-2 gap-2">
            {Array.from({ length: 6 }).map((_, i) => <Skeleton key={i} className="h-12" />)}
          </div>
          <Skeleton className="h-24" />
          <Skeleton className="h-12 rounded-full" />
        </div>
      </div>
    </div>
  </section>
);

export const TableRowsSkeleton = ({ rows = 5, cols = 6 }: { rows?: number; cols?: number }) => (
  <>
    {Array.from({ length: rows }).map((_, r) => (
      <tr key={r} className="border-b border-border">
        {Array.from({ length: cols }).map((_, c) => (
          <td key={c} className="p-3"><Skeleton className="h-4 w-full" /></td>
        ))}
      </tr>
    ))}
  </>
);

export const StatCardsSkeleton = ({ count = 6 }: { count?: number }) => (
  <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="rounded-xl border border-border bg-card p-4">
        <Skeleton className="mb-2 h-3 w-1/2" />
        <Skeleton className="h-8 w-20" />
      </div>
    ))}
  </div>
);

export const PageFallback = () => (
  <section className="min-h-screen bg-background px-4 py-12">
    <div className="mx-auto max-w-7xl">
      <Skeleton className="mb-4 h-8 w-1/3" />
      <Skeleton className="mb-8 h-4 w-1/2" />
      <ListingGridSkeleton count={6} />
    </div>
  </section>
);
